// extracted by mini-css-extract-plugin
export default {"feedbackButton":"feedbackButton-ceZJf","reportIssue":"reportIssue-MgpUW","contentFeedback":"contentFeedback-hjGnu","account-menu":"account-menu-_upeb"};